export enum CommandOptionType {
  STRING = 0,
  INTEGER = 1,
  BOOLEAN = 2,
  USER = 3,
  CHANNEL = 4,
  ROLE = 5,
  NUMBER = 6,
  SUB_COMMAND = 7,
  SUB_COMMAND_GROUP = 8,
}

export enum InteractionResponseType {
  CHANNEL_MESSAGE = 0,
  DEFERRED_CHANNEL_MESSAGE = 1,
  UPDATE_MESSAGE = 2,
  DEFERRED_UPDATE_MESSAGE = 3,
  MODAL = 4,
}

export interface CommandOptionChoice {
  name: string
  value: string
}

export interface CommandOption {
  name: string
  description: string
  type: CommandOptionType
  required: boolean
  choices: CommandOptionChoice[]
  autocomplete: boolean
}

export interface BotCommand {
  id: string
  bot_id: string
  name: string
  description: string
  options: CommandOption[]
  default_member_permissions: number
  created_at?: string
  updated_at?: string
}

export interface RegisterCommandRequest {
  bot_id: string
  name: string
  description: string
  options?: CommandOption[]
  default_member_permissions?: number
}

export interface UpdateCommandRequest {
  bot_id: string
  command_id: string
  name: string
  description: string
  options?: CommandOption[]
  default_member_permissions?: number
}

export interface CommandOptionValue {
  name: string
  value: string
}

export interface ExecuteCommandRequest {
  bot_id: string
  command_id: string
  channel_id: string
  group_id?: string | null
  options?: CommandOptionValue[]
}

export interface RequestAutocompleteRequest {
  bot_id: string
  command_id: string
  channel_id: string
  group_id?: string | null
  focused_option: string
  options?: CommandOptionValue[]
}

export interface InvokeMessageComponentRequest {
  bot_id: string
  message_id: string
  channel_id: string
  group_id?: string | null
  custom_id: string
  values?: string[]
}

export interface SubmitModalRequest {
  bot_id: string
  channel_id: string
  group_id?: string | null
  custom_id: string
  fields?: CommandOptionValue[]
}

export interface InteractionResult {
  type: InteractionResponseType
  content: string
  components_json: string
  modal_json: string
  ephemeral: boolean
  message_id?: string | null
}

export interface AutocompleteResult {
  choices: CommandOptionChoice[]
}
